<template>
    <div>
        <div v-if="translations.length === 0">
            No translations defined
        </div>

        <ul>
            <li v-for="translation in translations">
                {{ __('languages.only_flag.' + translation.language) }}:
                {{ translation.text }}
            </li>
        </ul>

        <div class="mt-1">
            <div class="input-group">
                <div class="input-group-prepend">
                    <select class="form-control" v-model="newTranslation.language">
                        <option value="">All languages</option>
                        <option v-for="countryCode in countryCodes" :value="countryCode">
                            {{ __('languages.with_flag.' + countryCode) }}
                        </option>
                    </select>
                </div>
                <input class="form-control" type="text" placeholder="Text.." v-model="newTranslation.text">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" @click="addNewEntry">
                        {{ __('actions.add') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Array,
        type: String,
        multiple: Boolean
    },

    data() {
        return {
            countryCodes: ['en', 'de', 'fr'],
            translations: this.value,
            newTranslation: {
                type: this.type,
                language: '',
                text: '',
            }
        }
    },

    methods: {
        addNewEntry() {
            this.translations.push(this.newTranslation);
            this.newTranslation = {
                type: this.type,
                language: '',
                text: '',
            };
        }
    },

    computed: {},

    watch: {
        translations: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        }
    }
}
</script>
